import React, { memo, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import api, { customPhotoUploadApi } from '../../../api'
import { ErrorModal } from '../../../components/Modal'
import CreateUserStyle from '../../../components/Modal/ScoreUserCreate/CreateUserStyle'
import RegionsData from '../../../components/Modal/ScoreUserCreate/Regions/regions.json'
import Button from '../../../components/Button'
import { useSelector } from 'react-redux'
import customMainApi from '../../../api'
import DistrictData from '../../../components/Modal/ScoreUserCreate/Regions/districts.json'
import VillageData from '../../../components/Modal/ScoreUserCreate/Regions/villages.json'
import formatPhoneNumber from '../../../helpers/PhoneWithSpaces'
import { message, Input } from 'antd'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		height: '90%',

		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		border: 'none',
		borderRadius: 15,
		overflowX: 'auto',
	},
}

const UpdateUserModal = (props) => {
	const { getRef = () => {}, onUpdated = () => {}, onClose = () => {} } = props
	const { getMe } = useSelector((state) => state.main)

	const errorRef = useRef()
	const [isOpenModal, setIsOpenModal] = useState(false)
	const [cardCode, setCardCode] = useState('')
	const [score, setScore] = useState('')
	const [katm, setKatm] = useState('')
	const [mib, setMib] = useState('')
	const [nasiya, setNasiya] = useState('')
	const [passport, setPassport] = useState('')
	const [phone, setPhone] = useState('')
	const [workplace, setWorkplace] = useState('')
	const [male, setMale] = useState('')
	const [userName, setUserName] = useState('')
	const [userSureName, setUserSureName] = useState('')
	const [userFathersName, setUserFathersName] = useState('')
	const [disData, setDisData] = useState([])
	const [villData, setVillData] = useState([])
	const [region, setRegion] = useState('')
	const [addresses, setAddress] = useState([])

	const [districtData, setDistrictData] = useState([])
	const [regionsData, setRegionsData] = useState([])
	const [citiesData, setCitiesData] = useState([])

	const [district, setDistrict] = useState('')
	const [village, setVillage] = useState('')
	const [path, setPath] = useState([])
	const [userFields, setUserFields] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [salary, setSalary] = useState('')

	const [comment, setComment] = useState('')
	const [language, setLanguage] = useState('')
	const [bornAdress, setBornAdress] = useState('')
	const [ageData, setAgeData] = useState('')
	// const [path, setPath] = useState([])
	console.log(path)
	useEffect(() => {
		const ref = {
			open: (data) => {
				console.log(data.U_Telephone)
				setIsOpenModal(true)
				setCardCode(
					get(data, 'CardCode', null) !== null ? get(data, 'CardCode', '') : '',
				)

				api(
					`BusinessPartners('${get(data, 'CardCode', '')}')?$select=CardName,U_Salary,U_PhotoId,U_age_data,U_Created,FreeText,U_workplace,U_Telephone,U_Respawn,U_Language,U_Gender,U_PS,U_KATM,U_Score,U_MIB,U_Nasiya,BPAddresses`,
				).then((res) => {
					console.log(JSON.parse(res.data))
					const data = JSON.parse(res.data)
					setUserName(
						get(data, 'CardName', null) !== null
							? get(data, 'CardName', '').split(' ')[1]
							: '',
					)
					setUserFathersName(
						get(data, 'CardName', null) !== null
							? get(data, 'CardName', '').split(' ')[2] +
									' ' +
									(get(data, 'CardName', '').split(' ')[3] || '')
							: '',
					)
					setUserSureName(
						get(data, 'CardName', null) !== null
							? get(data, 'CardName', '').split(' ')[0]
							: '',
					)

					setWorkplace(get(data, 'U_workplace', ''))
					setPhone(formatPhoneNumber(get(data, 'U_Telephone', '')))
					setMale(get(data, 'U_Gender', ''))
					setPassport(get(data, 'U_PS', ''))
					setScore(get(data, 'U_Score', ''))
					setKatm(get(data, 'U_KATM', ''))
					setMib(get(data, 'U_MIB', ''))
					setNasiya(get(data, 'U_Nasiya', ''))
					setLanguage(get(data, 'U_Language', ''))
					setAddress(get(data, 'BPAddresses', ''))
					setComment(get(data, 'FreeText', '-'))
					setBornAdress(get(data, 'U_Respawn', ''))

					setSalary(get(data, 'U_Salary, '))
					setAgeData(get(data, 'U_age_data', ''))
					const photoId = get(data, 'U_PhotoId', '')

					const photoPaths = photoId
						? photoId.includes(',')
							? photoId.split(',')
							: [photoId]
						: []

					const initialPath = photoPaths.map((path) => ({
						file: 'not empty',
						has: true,
						path,
						imgLoading: false,
					}))

					const finalPath =
						initialPath.length > 0
							? initialPath
							: [{ file: null, path: '', imgLoading: false }]

					setPath(finalPath)
				})

				// setData(data)

				// getBusinessPartners(get(data, 'CardCode', null) !== null ? get(data, 'CardCode', '') : '')
			},
			close: () => {
				setIsOpenModal(false)
				// resetStates()
			},
		}
		getRef(ref)
	}, [])

	const handleFileChange = (event, index) => {
		const updatedPath = [...path]
		updatedPath[index].file = event.target.files[0]
		setPath(updatedPath)
	}

	const uploadImg = async (index) => {
		const image = path[index]

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle' // Replace with actual title

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const updatedPath = [...path]
			updatedPath[index].imgLoading = true
			setPath(updatedPath)

			const res = await customPhotoUploadApi.post('assets/upload', formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			})

			const { key } = res.data
			updatedPath[index].path = key
			setPath(updatedPath)

			message.success('Успешно загружено!')
		} catch (err) {
			message.error('Ошибка загрузки')
		} finally {
			const updatedPath = [...path]
			updatedPath[index].imgLoading = false
			setPath(updatedPath)
		}
	}

	// View the uploaded image
	const viewImage = async (index) => {
		const image = path[index]

		try {
			const res = await customPhotoUploadApi.get(
				`assets/download/${image.path}`,
				{
					responseType: 'blob',
				},
			)

			const url = window.URL.createObjectURL(
				new Blob([res.data], { type: 'image/png' }),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error('Ошибка загрузки файла')
		}
	}

	// Add a new empty row for uploading images
	const addNewRow = () => {
		setPath([...path, { file: null, path: '', imgLoading: false }])
	}

	const deleteImage = async (index) => {
		const image = path[index]
		let url = `BusinessPartners('${cardCode}')`

		try {
			const res = await customPhotoUploadApi.delete(`assets/${image.path}`)
			const photoId = path
				.map((images) => images.path)
				.filter((p) => p !== image.path) // Correct filter syntax
				.join(',')
			await api.patch(url, {
				U_PhotoId: photoId,
			})
			deleteRow(index) // Remove the image from the state after deletion
			message.success('Успешно удалено!')
		} catch (error) {
			message.error('Ошибка удаления файла')
		}
	}

	// Delete a specific row
	const deleteRow = (index) => {
		setPath(path.filter((_, i) => i !== index))
	}

	// const resetStates = () => {
	// 	setCardCode('')
	// 	setScore('')
	// 	setKatm('')
	// 	setMib('')
	// 	setNasiya('')
	// 	setPassport('')
	// 	setPhone('')
	// 	setWorkplace('')
	// 	setMale('')
	// 	setUserName('')
	// 	setUserSureName('')
	// 	setUserFathersName('')
	// 	setDisData([])
	// 	setVillData([])
	// 	setRegion('')
	// 	setAddress([])
	// 	setDistrict('')
	// 	setVillage('')
	// 	setPath('')
	// 	setPINFL('')
	// 	setUserFields([])
	// 	setIsLoading(false)
	// 	setComment('')
	// 	setLanguage('')
	// 	setBornAdress('')
	// }

	// const getBusinessPartners = async (cardCode) => {
	// 	const data = await api(`BusinessPartners('${cardCode}')`).then((res) => {
	// 		return JSON.parse(res.data).value
	// 	})

	// 	// const selectElementData = data.map((item) => {
	// 	// 	return {
	// 	// 		value: item.CardCode,
	// 	// 		label: item.CardName,
	// 	// 	}
	// 	// })
	// 	setUserName(
	// 		get(data, 'CardName', null) !== null
	// 			? get(data, 'CardName', '').split(' ')[1]
	// 			: '',
	// 	)
	// 	setUserFathersName(
	// 		get(data, 'CardName', null) !== null
	// 			? get(data, 'CardName', '').split(' ')[2] +
	// 					' ' +
	// 					(get(data, 'CardName', '').split(' ')[3] || '')
	// 			: '',
	// 	)
	// 	setUserSureName(
	// 		get(data, 'CardName', null) !== null
	// 			? get(data, 'CardName', '').split(' ')[0]
	// 			: '',
	// 	)
	// 	setWorkplace(
	// 		get(data, 'U_workplace', null) !== null
	// 			? get(data, 'U_workplace', '')
	// 			: '',
	// 	)
	// 	setPhone(
	// 		get(data, 'U_Telephone', null) !== null
	// 			? get(data, 'U_Telephone', '')
	// 			: '',
	// 	)
	// 	setMale(
	// 		get(data, 'U_Gender', null) !== null ? get(data, 'U_Gender', '') : '',
	// 	)
	// 	setPassport(
	// 		get(data, 'U_PS', null) !== null ? get(data, 'U_PS', '') : '',
	// 	)
	// 	setScore(
	// 		get(data, 'U_Score', null) !== null ? get(data, 'U_Score', '') : '',
	// 	)
	// 	setKatm(
	// 		get(data, 'U_KATM', null) !== null ? get(data, 'U_KATM', '') : '',
	// 	)
	// 	setMib(get(data, 'U_MIB', null) !== null ? get(data, 'U_MIB', '') : '')
	// 	setNasiya(
	// 		get(data, 'U_Nasiya', null) !== null ? get(data, 'U_Nasiya', '') : '',
	// 	)

	// 	setData(data)
	// }
	useEffect(() => {
		fetchRegions()
	}, [])

	const fetchDistrictsWithoutId = () => {
		api
			.get(`U_ADDRESS_DISCRTICT`, {
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			})
			.then((res) => {
				const items = JSON.parse(res.data).value
				console.log(items)
				setDistrictData(items)
				// console.log(res.data)
			})
	}

	const fetchDistricts = (cityCode) => {
		if (cityCode.trim()) {
			api
				.get(`U_ADDRESS_DISCRTICT?$filter=U_CityCode eq '${cityCode}'`)
				.then((res) => {
					const items = JSON.parse(res.data).value
					console.log(items)
					setDistrictData(items)
				})
				.catch((error) => {
					console.error('Error fetching districts:', error)
				})
		}
	}

	const fetchCities = (rgId) => {
		// ?$filter=U_RegionCode eq rgId
		if (rgId.trim()) {
			api
				.get(`U_ADDRESS_CITY?$filter=U_RegionCode eq '${rgId}'`)
				.then((res) => {
					const items = JSON.parse(res.data).value
					console.log(items)
					setCitiesData(items)
					// console.log(res.data)
				})
		}
	}
	const fetchCitiesWithoutId = () => {
		// ?$filter=U_RegionCode eq rgId

		api
			.get(`U_ADDRESS_CITY`, {
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			})
			.then((res) => {
				const items = JSON.parse(res.data).value
				console.log(items)
				setCitiesData(items)
				// console.log(res.data)
			})
	}

	const fetchRegions = () => {
		api.get('U_ADDRESS_REGION').then((res) => {
			const items = JSON.parse(res.data).value
			console.log(items)
			setRegionsData(items)
			// console.log(res.data)
		})
	}

	const handleAddressChange = (index, field, value) => {
		const newAddresses = addresses.map((address, i) => {
			if (i === index) {
				return { ...address, [field]: value }
			}
			return address
		})
		setAddress(newAddresses)
	}

	useEffect(() => {
		console.log(phone)
	}, [phone])

	const submit = () => {
		setIsLoading(true)
		let url = `BusinessPartners('${cardCode}')`
		const photoId = path
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')
		api
			.patch(url, {
				// SalesPersonCode: getMe.SalesPersonCode || -1,
				U_workplace: workplace,
				// CardCode: serie, //CardCode
				CardName: `${userSureName} ${userName} ${userFathersName}`, //UserName, userSurname, userFathersName,
				// CardType: 'cCustomer', // By default
				// GroupCode: 100, // By default
				U_Telephone: `${phone}`,
				Currency: '##', // Bydefault
				U_Gender: male, // Erkak Ayol
				U_PS: passport, //Pasport
				U_Score: Number(score.split(' ')[0]),
				U_KATM: katm, //Tavsirlab bergan yangi narsam
				U_MIB: mib, //Tavsirlab bergan yangi narsam
				U_Nasiya: nasiya, //Tavsirlab bergan yangi narsam
				Valid: 'tYES',
				U_Salary: salary,
				FreeText: comment,
				U_Respawn: bornAdress,
				U_Language: language,
				U_PhotoId: photoId,
				BPAddresses: addresses.map((address, idx) => ({
					AddressName: idx + 1, // Auto-generate something here if needed
					// Street: address.Street,
					RowNum: address.RowNum,
					BPCode: address.BPCode,
					U_CityCode:
						address.U_CityCode.length > 4
							? Number(address.U_CityCode.split(' - ')[1])
							: address.U_CityCode, // Village
					U_DistrictCode:
						address.U_DistrictCode.length > 4
							? Number(address.U_DistrictCode.split(' - ')[1])
							: address.U_DistrictCode, // District
					U_RegionCode:
						address.U_RegionCode.length > 4
							? Number(address.U_RegionCode.split(' - ')[1])
							: address.U_RegionCode, // Region
					BuildingFloorRoom: address.BuildingFloorRoom,
					StreetNo: address.StreetNo,
				})),
			})
			.then(() => {
				onUpdated()
				setIsOpenModal(false)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => setIsLoading(false))
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OCRD'",
				},
				headers: {
					Prefer: 'odata.maxpagesize=100',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	useEffect(() => {
		userFieldsFn()
		fetchCitiesWithoutId()
		fetchDistrictsWithoutId()
	}, [])

	const getRegion = (text) => {
		let a = Number(text.split(' - ')[1])

		let changed_data = DistrictData.filter((v) => {
			return a === Number(get(v, 'region_id', 0))
		})
		setDisData(changed_data)
		setRegion(text)
		setDistrict('')
		setVillage('')
	}

	const getDistrict = (text) => {
		let a = Number(text.split(' - ')[1])

		let changed_data = VillageData.filter((v) => {
			return a === Number(get(v, 'district_id', 0))
		})
		setVillData(changed_data)
		setDistrict(text)
		setVillage('')
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<CreateUserStyle>
				<div className="card">
					<p className="title">
						{'Изменить пользователя'}
						{'!'}
					</p>
					<div className="flex flex-col gap-4">
						<div className="flex items-center gap-2">
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Имя</p>
								<input
									type="text"
									placeholder="Имя"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									value={userName}
									onChange={(v) => setUserName(v.target.value)}
								/>
							</div>
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Фамилия</p>
								<input
									type="text"
									placeholder="Фамилия"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={userSureName}
									onChange={(v) => setUserSureName(v.target.value)}
								/>
							</div>
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Отчество</p>
								<input
									type="text"
									placeholder="Отчество"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={userFathersName}
									onChange={(v) => setUserFathersName(v.target.value)}
								/>
							</div>
						</div>
						{addresses.map((address, index) => {
							const region = regionsData?.find(
								(value) => address.U_RegionCode === Number(value.Code),
							)
							const displayRegion = region ? `${region.Name}` : ''

							const city = citiesData?.find(
								(value) => address.U_CityCode === Number(value.Code),
							)
							const displayCity = city ? `${city.Name}` : ''

							const district = districtData?.find(
								(value) => address.U_DistrictCode === Number(value.Code),
							)
							const displayDistrict = district ? `${district.Name}` : ''

							return (
								<div className="flex flex-col gap-5 mt-4" key={index}>
									{index === 0 ? (
										<b>Адрес прописки</b>
									) : (
										<b>Адрес проживание</b>
									)}
									<hr className="w-full border-1 font-extrabold border-black" />

									<div className="flex items-center gap-2">
										<div className="flex flex-col gap-2 items-start">
											<p>Область</p>
											<input
												type="text"
												placeholder="Область"
												list="region"
												defaultValue={displayRegion}
												onChange={(v) => {
													getRegion(v.target.value)
													fetchCities(
														v.target.value.split(' - ')[1]
															? v.target.value.split(' - ')[1]
															: ' ',
													)
													handleAddressChange(
														index,
														'U_RegionCode',
														v.target.value,
													)
												}}
												className={
													'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
												}
											/>
											<datalist id="region">
												{regionsData.map((v, i) => (
													<option key={i} value={`${v.Name} - ${v.Code}`} />
												))}
											</datalist>
										</div>
										<div className="flex flex-col items-start gap-2">
											<p>Город | Район</p>
											<input
												type="text"
												placeholder="Город | Район"
												list="village"
												defaultValue={displayCity}
												onChange={(v) => {
													setVillage(v.target.value)
													fetchDistricts(
														v.target.value.split(' - ')[1]
															? v.target.value.split(' - ')[1]
															: ' ',
													)
													handleAddressChange(
														index,
														'U_CityCode',
														v.target.value,
													)
												}}
												className={
													'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
												}
											/>
											<datalist id="village">
												{citiesData.map((v, i) => (
													<option key={i} value={`${v.Name} - ${v.Code}`} />
												))}
											</datalist>
										</div>
										<div className="flex flex-col gap-2 items-start">
											<p>Кишлак | Махаляя</p>
											<input
												type="text"
												placeholder="Кишлак | Махаляя"
												list="district"
												defaultValue={displayDistrict}
												onChange={(v) => {
													getDistrict(v.target.value)
													handleAddressChange(
														index,
														'U_DistrictCode',
														v.target.value,
													)
												}}
												className={
													'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
												}
											/>
											<datalist id="district">
												{districtData.map((v, i) => (
													<option key={i} value={`${v.Name} - ${v.Code}`} />
												))}
											</datalist>
										</div>
									</div>
									<div className="flex items-center gap-2">
										<div className="flex flex-col gap-2 items-start w-full">
											<p>Название улицы</p>
											<input
												type="text"
												placeholder="Название улицы"
												value={address.StreetNo}
												onChange={(v) =>
													handleAddressChange(index, 'StreetNo', v.target.value)
												}
												className={
													'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
												}
											/>
										</div>
										<div className="flex flex-col items-start gap-2 w-full">
											<p>Номер дома</p>
											<input
												type="text"
												placeholder="Номер дома"
												value={address.BuildingFloorRoom}
												onChange={(v) =>
													handleAddressChange(
														index,
														'BuildingFloorRoom',
														v.target.value,
													)
												}
												className={
													'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full  '
												}
											/>
										</div>
									</div>
								</div>
							)
						})}
						<div className="flex items-center gap-2">
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Паспорт/ПИНФЛ</p>
								<input
									type="text"
									placeholder="Паспорт/ПИНФЛ"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={passport}
									onChange={(v) => setPassport(v.target.value)}
								/>
							</div>
							<div className="flex flex-col items-start gap-2 w-full">
								<p>Телефон</p>
								<input
									type="text"
									placeholder="Телефон"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={phone}
									onChange={(v) => setPhone(v.target.value)}
								/>
							</div>
						</div>{' '}
						<div className="flex items-center gap-2">
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Место рождения</p>
								<input
									type="text"
									placeholder="Место рождения"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full  '
									}
									value={bornAdress}
									onChange={(v) => setBornAdress(v.target.value)}
								/>
							</div>
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Дата рождение</p>
								<input
									type="text"
									placeholder="Дата рождение"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={ageData}
									onChange={(v) => setAgeData(v.target.value)}
								/>
							</div>
						</div>
						<div className="flex items-center gap-2">
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Место работы</p>
								<input
									type="text"
									placeholder="Место работы"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									value={workplace}
									onChange={(v) => setWorkplace(v.target.value)}
								/>
							</div>
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Зарплата</p>
								<input
									type="text"
									placeholder="Зарплата"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									value={salary}
									onChange={(v) => setSalary(v.target.value)}
								/>
							</div>
						</div>
						<div className="flex items-center gap-2">
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Статус</p>
								<select
									placeholder="Статус"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={score}
									onChange={(v) => setScore(v.target.value)}
								>
									<option value={''}></option>
									{userFields
										?.find((item) => item.Name === 'Score')
										?.ValidValuesMD.map((value) => (
											<option value={value.Value}>
												{' '}
												{value.Value} - {value.Description}
											</option>
										))}
								</select>
							</div>

							<div className="flex flex-col gap-2 items-start w-full">
								<p>Насия</p>
								<select
									placeholder="Насия"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={nasiya}
									onChange={(v) => setNasiya(v.target.value)}
								>
									<option value={''}></option>
									{userFields
										?.find((item) => item.Name === 'Nasiya')
										?.ValidValuesMD.map((value) => (
											<option value={value.Value}>{value.Description}</option>
										))}
								</select>
							</div>
						</div>
						<div className="flex items-center gap-2">
							<div className="flex flex-col gap-2 items-start w-full">
								<p>KATM</p>
								<select
									placeholder="Katm"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									value={katm}
									onChange={(v) => setKatm(v.target.value)}
								>
									<option value={''}></option>
									{userFields
										?.find((item) => item.Name === 'KATM')
										?.ValidValuesMD.map((value) => (
											<option value={value.Value}>{value.Description}</option>
										))}
								</select>
							</div>
							<div className="flex flex-col gap-2 items-start w-full">
								<p>MIB</p>
								<select
									placeholder="U_MIB"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									value={mib}
									onChange={(v) => setMib(v.target.value)}
								>
									<option value={''}></option>
									{userFields
										?.find((item) => item.Name === 'MIB')
										?.ValidValuesMD.map((value) => (
											<option value={value.Value}>{value.Description}</option>
										))}
								</select>
							</div>
						</div>
						<div className="flex items-center gap-2">
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Язык отправки смс </p>
								<select
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
									}
									value={language}
									onChange={(e) => setLanguage(e.target.value)}
								>
									<option value="">{''}</option>

									{userFields
										?.find((item) => item.Name === 'Language')
										?.ValidValuesMD.map((value) => (
											<option value={value.Value}>{value.Description}</option>
										))}
								</select>
							</div>
							<div className="flex flex-col gap-2 items-start w-full">
								<p>Комментария</p>
								<input
									type="text"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									value={comment}
									onChange={(v) => setComment(v.target.value)}
								/>
							</div>
						</div>
					</div>
					<div className="mt-10">
						{path.map((image, index) =>
							image.has ? (
								image.path && (
									<div
										key={index}
										className="flex w-full items-start flex-col gap-3 mt-5 mb-10"
									>
										<div>
											<p className="font-bold">Фото-{index + 1}</p>
										</div>
										<div className="flex items-center gap-3">
											<Button
												onClick={() => viewImage(index)}
												className="h-12 w-[100px] rounded-3xl bg-[#0A4D68] text-white"
											>
												Скачать
											</Button>
											<button
												onClick={() => deleteImage(index)}
												className="h-[40px] w-[150px] rounded-lg p-2 bg-red-500 text-white"
											>
												Удалить
											</button>
											{index === path.length - 1 && (
												<Button
													onClick={addNewRow}
													className="h-12 w-[100px] rounded-3xl bg-[#0A4D68] text-white"
												>
													Добавить
												</Button>
											)}
										</div>
									</div>
								)
							) : (
								<div
									key={index}
									className="flex w-full flex-col items-start gap-3 mt-5 mb-10"
								>
									<div>
										<p className="font-bold">Фото-{index + 1}</p>
									</div>
									<div className="flex items-center gap-3">
										<Input
											type="file"
											onChange={(e) => handleFileChange(e, index)}
											className="w-full"
										/>
										<Button
											onClick={() => uploadImg(index)}
											isLoading={image.imgLoading}
											className="h-12 w-[100px] rounded-3xl bg-[#0A4D68] text-white"
										>
											Загрузить
										</Button>
										{image.path && (
											<>
												<Button
													onClick={() => viewImage(index)}
													className="h-12 w-[100px] rounded-3xl bg-[#0A4D68] text-white"
												>
													Скачать
												</Button>
												<button
													onClick={() => deleteImage(index)}
													className="h-[40px] w-[150px] rounded-lg p-2 bg-red-500 text-white"
												>
													Удалить
												</button>
											</>
										)}
										{index !== 0 && (
											<button
												onClick={() => deleteRow(index)}
												className="h-[40px] w-[100px] rounded-lg p-2 bg-red-500 text-white"
											>
												Отмена
											</button>
										)}
										{index === path.length - 1 && (
											<Button
												onClick={addNewRow}
												className="h-12 w-[100px] rounded-3xl bg-[#0A4D68] text-white"
											>
												Добавить
											</Button>
										)}
									</div>
								</div>
							),
						)}
					</div>

					<div className="flex gap-4 justify-center my-4">
						<div className="flex gap-1">
							<input
								type="radio"
								id="male"
								name="fav_language"
								checked={male === 'Male'}
								onChange={(v) => {
									setMale(v.target.value)
									console.log(v.target.value)
								}}
								value="Male"
							/>

							<label htmlFor="male">Мужчина</label>
						</div>
						<div className="flex gap-1">
							<input
								type="radio"
								id="female"
								name="fav_language"
								checked={male === 'Female'}
								onChange={(v) => {
									setMale(v.target.value)
									console.log(v.target.value)
								}}
								value="Female"
							/>
							<label htmlFor="female">Женщина</label>
						</div>
					</div>

					<div className="centerCard">
						<button
							className="bg-red-500 text-white py-2 px-4 rounded-md btn"
							onClick={() => {
								onClose()
								setIsOpenModal(false)
							}}
						>
							{'Нет'}
						</button>
						<Button
							isLoading={isLoading}
							className={'btn'}
							// disabled={
							// 	// userName.length <= 0 ||
							// 	// userSureName.length <= 0 ||
							// 	// userFathersName.length <= 0 ||
							// 	// region.length <= 0 ||
							// 	// district.length <= 0 ||
							// 	// village.length <= 0 ||
							// 	// passportAdress.length <= 0 ||
							// 	// liveAdress.length <= 0 ||
							// 	// cardCode.length <= 0 ||
							// 	// passport.length <= 0 ||
							// 	// phone.length <= 0 ||
							// 	// workplace.length <= 0 ||
							// 	// male.length <= 0
							// }
							onClick={submit}
						>
							{'Да'}
						</Button>
					</div>
				</div>
			</CreateUserStyle>
			<ErrorModal getRef={(r) => (errorRef.current = r)} />
		</Modal>
	)
}

export default memo(UpdateUserModal)
